import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-verification-dtz-choice',
  templateUrl: './verification-dtz-choice.component.html',
  styleUrls: ['./verification-dtz-choice.component.css']
})
export class VerificationDtzChoiceComponent {

  readonly USE_PHONE_QR_CODE_SCAN = 'assets/img/use-phone-QR-Code-scan-icon.png';
  readonly PRINTED_CERTIFICATE_ICON = 'assets/img/printed-certificate-icon.png';
  readonly UPLOAD_PDF_ICON = 'assets/img/upload-pdf-icon.png';

  constructor(private router: Router) {
  }

  printedCertificate(): void {
    this.router.navigate(['verification-dtz-form']).then(() => window.scrollTo({top: 0}));
  }

  qrCodeCertificate(): void {
    this.router.navigate(['verification-dtz-qr-code']).then(() => window.scrollTo({top: 0}));
  }

  pdfCertificate(): void {
    this.router.navigate(['verification-dtz-pdf-form']).then(() => window.scrollTo({top: 0}));
  }
}
